import React from "react";
import { Autocomplete, TextField } from "@mui/material";
import { Controller } from "react-hook-form";
import { useSelector } from "react-redux";
import { get } from "lodash";
import { getSubdivisionOptions } from "../../api/codelist/codeListsSlice";

const OMNSubdivisionSelect = ({
  name,
  label = "Country Subdivision",
  control,
  errors,
  readOnly = false,
  disabled,
}) => {
  const subdivisionOptions = useSelector(getSubdivisionOptions);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        return (
          <Autocomplete
            {...field}
            id={name}
            data-testid={`${name}-select`}
            options={subdivisionOptions}
            readOnly={readOnly}
            getOptionLabel={(option) =>
              option.code ? `${option.name} (${option.code})` : ""
            }
            renderInput={(params) => (
              <TextField
                {...params}
                data-testid={`${name}-input`}
                label={label}
                error={!!get(errors, name, null)}
                helperText={get(errors, name, {})?.message}
              />
            )}
            isOptionEqualToValue={(option, value) =>
              option.code === value?.code
            }
            onChange={(_, value) => field.onChange(value)}
            value={field.value || null}
            disabled={disabled}
          />
        );
      }}
    />
  );
};

export default OMNSubdivisionSelect;
